var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"SocialLinks",class:_vm.classes},_vm._l((_vm.items),function(item){return _c('li',{key:item.id},[_c('a',{staticClass:"gtm-click-social",attrs:{"href":item.providerLink,"data-category":item.providerName,"target":"_blank"}},[_c('BaseIcon',{attrs:{"icon":item.providerName,"color":_vm.color}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }